import React, { useEffect, useState } from 'react';
import AgConvergeAgendaPDF from '../assets/AgConverge_2026_Agenda.pdf';

import CarouselImg from '../images/Carousel.jpg';
import Carousel1Img from '../images/Carousel1.jpg';
import Carousel4Img from '../images/Carousel4.jpg';
import Carousel5Img from '../images/Carousel5.jpg';
import Carousel6Img from '../images/Carousel6.jpg';
import BenSteffenImg from '../images/Ben_Stiffen.jpeg';
import ConnieBowenImg from '../images/Connie_Bowen.jpeg';
import PosterSessionFlyer from '../images/PosterSessionFlyer.png';
import FTACPoster from '../images/FTAC_poster.jpeg';


const REGISTRATION_URL =
  'https://cvent.me/9E05M7';

const FTAC_STARTUP_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUQ0JJR0pIR01ZSlZIMzRXV0VPS0hJWEVaTy4u&route=shorturl';

const STUDENT_REGISTRATION_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUNURaN1haQUs2NEI3UlZBQkJOREtIOU05WS4u&route=shorturl';


/* =========================================================
   HOTEL OPTIONS
   ========================================================= */

const hotelOptions = [

  {
    name: 'Grand Island Casino Resort',

    label:
      'Official AgConverge Hotel',

    address:
      '777 E. Fonner Park Road, Grand Island, NE 68801',

    phone:
      '(308) 675-5600',

    description:
      'Located directly at Fonner Park, Grand Island Casino Resort is the official hotel for Spur AgConverge 2026 attendees.',

    url:
      'https://www.grandislandresort.com/hotel.html',

    isOfficialBlock: true,

    specialRate:
      '$119.95/night',

    groupCode:
      '10300N',

    bookBy:
      'October 16, 2026',

    blockMessage:
      'Use group code 10300N when booking your room to receive the special AgConverge rate. The discounted room block is subject to availability.',
  },


  {
    name:
      'Travelodge by Wyndham Grand Island',

    label:
      'Adjacent to Fonner Park',

    address:
      '1311 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 594-0123',

    description:
      'A convenient budget-friendly hotel adjacent to Fonner Park and close to the Heartland Events Center. Amenities include free Wi-Fi, free parking, pet-friendly rooms, and airport shuttle service.',

    url:
      'https://www.wyndhamhotels.com/travelodge/grand-island-nebraska/grand-island-travelodge/overview',
  },


  {
    name:
      'SureStay Plus Hotel by Best Western Grand Island',

    label:
      'About 0.5 mile from Fonner Park',

    address:
      '2603 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 384-4380',

    description:
      'A nearby hotel on South Locust Street within easy reach of Fonner Park. Guests have access to complimentary breakfast, Wi-Fi, an indoor pool, fitness facilities, and free parking.',

    url:
      'https://www.bestwestern.com/en_US/book/hotel-rooms.54219.html',
  },


  {
    name:
      'Island Inn',

    label:
      'Near Fonner Park',

    address:
      '2311 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 382-1815',

    description:
      'A simple and affordable lodging option on South Locust Street close to the Fonner Park event area. Rooms include refrigerators, wireless internet, and free local calls.',

    url:
      'http://www.stayislandinn.com',
  },


  {
    name:
      'Best Western Plus Grand Island Inn & Suites',

    label:
      'About 1 mile from the event center',

    address:
      '2707 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 675-5656',

    description:
      'Located minutes from the Heartland Events Center, Fonner Park, and Nebraska State Fairgrounds. Amenities include a full hot breakfast, indoor heated pool, fitness center, Wi-Fi, and free parking.',

    url:
      'https://www.bestwestern.com/en_US/book/grand-island/hotel-rooms/best-western-plus-grand-island-inn-suites/propertyCode.28071.html',
  },


  {
    name:
      'Ramada by Wyndham Midtown Grand Island',

    label:
      'Near Fonner Park',

    address:
      '2503 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 384-1330',

    description:
      'A full-service hotel near the Heartland Events Center and Fonner Park with an indoor pool, on-site dining, conference facilities, breakfast, Wi-Fi, and parking.',

    url:
      'https://www.wyndhamhotels.com/ramada/grand-island-nebraska/ramada-midtown-grand-island/overview',
  },


  {
    name:
      'MainStay Suites Grand Island',

    label:
      'About 1 mile from Fonner Park',

    address:
      '3051 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 646-2091',

    description:
      'An extended-stay hotel near the Nebraska State Fairgrounds and Fonner Park with apartment-style suites, in-room kitchens, complimentary Wi-Fi, breakfast, and parking.',

    url:
      'https://www.choicehotels.com/nebraska/grand-island/mainstay-hotels/ne131',
  },

];


/* =========================================================
   SESSION DATA
   ========================================================= */

const sessionData = {

  day1: [

    {
      icon:
        'fa-mug-hot',

      title:
        'Registration & Coffee',

      desc:
        'Exhibits and Startup Demonstration Stations open.',

      time:
        '8:00 – 9:00 AM',

      type:
        'networking',
    },


    {
      icon:
        'fa-microphone',

      title:
        'Welcome & Framing the Two Days',

      time:
        '9:00 – 9:10 AM',
    },


    {
      icon:
        'fa-bullhorn',

      title:
        'Opening Address',

      desc:
        'Ankit Chandra, Spur Ventures.',

      time:
        '9:10 – 9:25 AM',
    },


    /* =====================================================
       PRODUCER KEYNOTE — BEN STEFFEN
       ===================================================== */

    {
      icon:
        'fa-tractor',

      title:
        'Producer Keynote',

      desc:
        'What Farms Need Now: A Producer’s View on AgTech Innovation.',

      time:
        '9:25 – 10:00 AM',

      badge:
        'Keynote',

      type:
        'featured',

      isKeynote:
        true,

      speakerName:
        'Ben Steffen',

      speakerRole:
        'Producer Keynote Speaker',

      speakerImage:
        BenSteffenImg,

      speakerBio:
        'Ben Steffen is a proud Nebraska farmer, business owner, and longtime advocate for agriculture and rural communities. A University of Nebraska–Lincoln graduate, he farms land that has been in his family for more than 130 years and serves as President of Steffen Ag Inc. He is a former President of Ag Builders of Nebraska and currently chairs the Nebraska Rural Radio Association.',
    },


    {
      icon:
        'fa-coffee',

      title:
        'Networking Break',

      desc:
        'Startup Demonstration Stations featured.',

      time:
        '10:00 – 10:30 AM',

      type:
        'break',
    },


    {
      icon:
        'fa-rocket',

      title:
        'FTAC Phase 1: Startup Showcase',

      desc:
        'Eight Selected Startups: eight minutes pitch; your potential customers are in the room.',

      time:
        '10:30 – 11:45 AM',

      badge:
        'FTAC Phase 1',

      type:
        'featured',

      chairName:
        'Ankit Chandra',

      chairEmail:
        'achandra@unl.edu',

      coChairName:
        'Joy Eakin',

      coChairEmail:
        'jeakin@nutechventures.org',
    },


    {
      icon:
        'fa-people-arrows',

      title:
        'Transition to Lunch',

      desc:
        'Transition from the morning program to lunch.',

      time:
        '11:45 AM – 12:00 PM',

      type:
        'break',
    },


    /* =====================================================
       INDUSTRY KEYNOTE — CONNIE BOWEN
       ===================================================== */

    {
      icon:
        'fa-utensils',

      title:
        'Lunch & Industry Keynote',

      desc:
        'Where Capital Is Going: Market Conditions and the Future of AgTech Investment. The keynote is scheduled from 12:20–12:45 PM.',

      time:
        '12:00 – 1:00 PM',

      badge:
        'Keynote · Lunch',

      type:
        'meal',

      isKeynote:
        true,

      speakerName:
        'Connie Bowen',

      speakerRole:
        'Industry Keynote Speaker',

      speakerImage:
        ConnieBowenImg,

      speakerBio:
        'Connie Bowen is a leader in agricultural innovation and investment with experience investing in 50+ agtech startups over the past decade. She is the founding General Partner at Farmhand Ventures, an impact investment firm shaping the Future of Work in Agriculture by enabling strategic programs and innovation to make farm work more attractive, productive, and sustainable—improving the lives and livelihoods of farmers, farmworkers, and rural communities. Connie has built a career connecting agricultural technology with practical farming needs and sustainable technology investment at The Yield Lab, AgLaunch, Chess Ag Full Harvest Partners, and Grape Arbor Ventures.',
    },


    {
      icon:
        'fa-table',

      title:
        'Track A: FTAC Phase 2 — Farmer Evaluation Roundtables',

      desc:
        'Farmers, founders, and facilitators participate in a closed evaluation session.',

      time:
        '1:00 – 2:15 PM',

      badge:
        'Closed session',

      type:
        'track',

      chairName:
        'Ankit Chandra',

      chairEmail:
        'achandra@unl.edu',

      coChairName:
        'Joy Eakin',

      coChairEmail:
        'jeakin@nutechventures.org',
    },


    {
      icon:
        'fa-users',

      title:
        'Track B: Industry–Academia Partnership Panel',

      desc:
        'Concurrent Session — Track B runs alongside FTAC Phase 2 (Track A). From Research to Impact: the Industry–Academia Partnership Panel runs from 1:05–1:45 PM, followed by open demonstration time until 2:15 PM.',

      time:
        '1:00 – 2:15 PM',

      badge:
        'Concurrent Session · Track B',

      type:
        'track',

      chairName:
        'Ankit Chandra',

      chairEmail:
        'achandra@unl.edu',

      coChairName:
        'Ryan Anderson',

      coChairEmail:
        'randerson13@unl.edu',
    },


    {
      icon:
        'fa-robot',

      title:
        'Afternoon Break',

      desc:
        'Robotics & Technology Demonstration Arena featured.',

      time:
        '2:15 – 2:45 PM',

      type:
        'break',

      chairName:
        'Dr. Santosh Pitla',

      chairEmail:
        'spitla@nebraska.edu',
    },


    {
      icon:
        'fa-award',

      title:
        'FTAC Phase 3: Producer Verdict & Farm Awards',

      desc:
        'Roundtable reports, judging panel, producer verdicts, and awards presentation.',

      time:
        '2:45 – 3:45 PM',

      badge:
        'FTAC Phase 3',

      type:
        'featured',
    },


    {
      icon:
        'fa-coffee',

      title:
        'Break',

      desc:
        'Short transition before the afternoon fireside chat.',

      time:
        '3:45 – 4:00 PM',

      type:
        'break',
    },


    {
      icon:
        'fa-comments',

      title:
        'Founder × Farmer Fireside Chat I',

      desc:
        'Beyond the Pitch: a founder × farmer conversation on technology adoption and real-world use.',

      time:
        '4:00 – 4:40 PM',

      badge:
        'Fireside chat',

      type:
        'featured',

      startupName:
        'iCrop',

      farmerName:
        'Clark McPheeters',

      chairName:
        'Mark Stone',

      chairEmail:
        'mark.stone@unl.edu',
    },


    {
      icon:
        'fa-flag-checkered',

      title:
        'Day 1 Wrap',

      time:
        '4:40 – 4:55 PM',
    },


    {
      icon:
        'fa-handshake',

      title:
        'Networking Reception & Student Poster Session',

      desc:
        'AgConverge Connect partner meetups, student posters, networking, and open exhibits.',

      time:
        '5:00 – 6:30 PM',

      badge:
        'Reception',

      type:
        'networking',

      chairName:
        'Ishani Lal',

      chairEmail:
        'ilal2@unl.edu',

      coChairName:
        'Alexa Davis',

      coChairEmail:
        'alexa.davis@nebraska.gov',
    },

  ],


  day2: [

    {
      icon:
        'fa-chart-line',

      title:
        'Investor–Startup Breakfast',

      desc:
        'Invitation-only breakfast for showcase startups, investors, and corporate venture teams.',

      time:
        '8:00 – 9:00 AM',

      badge:
        'Invitation only',

      type:
        'meal',

      chairName:
        'Jessica Rudolph',

      chairEmail:
        'jessica@investnebraska.com',
    },


    {
      icon:
        'fa-mug-hot',

      title:
        'Coffee & Networking',

      desc:
        'AgConverge Connect partner meetups, open exhibits, and students presenting at their posters.',

      time:
        '8:15 – 9:00 AM',

      badge:
        'Open networking',

      type:
        'networking',
    },


    {
      icon:
        'fa-microphone',

      title:
        'Welcome Back',

      time:
        '9:00 – 9:05 AM',
    },


    {
      icon:
        'fa-comments',

      title:
        'Convergence of NSF Innovation Engines',

      desc:
        'Conversation on translation and commercialization of agtech through the Spur and Innovation engines.',

      time:
        '9:05 – 9:40 AM',

      badge:
        'Panel',

      type:
        'featured',

      chairName:
        'Ishani Lal',

      chairEmail:
        'ilal2@unl.edu',

      coChairName:
        'Josh Gelinske',

      coChairEmail:
        'josh@farmsengine.com',
    },


    {
      icon:
        'fa-users',

      title:
        'Women in Midwest AgTech',

      desc:
        'Women Shaping the Future of Agricultural Innovation.',

      time:
        '9:40 – 10:25 AM',

      badge:
        'Panel',

      type:
        'featured',

      chairName:
        'Ishani Lal',

      chairEmail:
        'ilal2@unl.edu',

      coChairName:
        'Alexa Davis',

      coChairEmail:
        'alexa.davis@nebraska.gov',
    },


    {
      icon:
        'fa-robot',

      title:
        'Morning Break',

      desc:
        'Robotics & Technology Demonstration Arena featured.',

      time:
        '10:25 – 10:50 AM',

      type:
        'break',

      chairName:
        'Dr. Santosh Pitla',

      chairEmail:
        'spitla@nebraska.edu',
    },


    {
      icon:
        'fa-leaf',

      title:
        'Bio-economy Panel',

      desc:
        'From Commodity to Bioproduct: Building the Regional Bio-economy.',

      time:
        '10:50 – 11:35 AM',

      badge:
        'Panel',

      type:
        'featured',

      chairName:
        'Zane Gernhart',

      chairEmail:
        'zgernhart2@unl.edu',
    },


    {
      icon:
        'fa-bullhorn',

      title:
        'Closing Address',

      desc:
        'Ankit Chandra, Spur Ventures.',

      time:
        '11:35 – 11:50 AM',
    },


    {
      icon:
        'fa-flag-checkered',

      title:
        'Farewell',

      time:
        '11:50 AM – 12:00 PM',
    },


    {
      icon:
        'fa-utensils',

      title:
        'Networking Lunch & Departures',

      desc:
        'Continue conversations over lunch before departing.',

      time:
        '12:00 PM',

      badge:
        'Optional',

      type:
        'meal',
    },

  ],

};


/* =========================================================
   DAY TABS
   ========================================================= */

const tabs = [

  {
    key:
      'day1',

    day:
      'Day 1',

    date:
      'Tuesday, November 17',
  },

  {
    key:
      'day2',

    day:
      'Day 2',

    date:
      'Wednesday, November 18',
  },

];


/* =========================================================
   SPUR 2025 HIGHLIGHT IMAGES
   ========================================================= */

const heroSlides = [

  {
    image:
      CarouselImg,

    alt:
      'Spur Ventures event',

    label:
      '2025 Highlight 01',

    position:
      'center',
  },


  {
    image:
      Carousel1Img,

    alt:
      'Spur Ventures conference gathering',

    label:
      '2025 Highlight 02',

    position:
      'center',
  },


  {
    image:
      Carousel4Img,

    alt:
      'Agricultural innovation event',

    label:
      '2025 Highlight 03',

    position:
      'center',
  },


  {
    image:
      Carousel5Img,

    alt:
      'AgTech networking event',

    label:
      '2025 Highlight 04',

    position:
      'center',
  },


  {
    image:
      Carousel6Img,

    alt:
      'Spur Ventures community event',

    label:
      '2025 Highlight 05',

    position:
      'center',
  },

];


/* =========================================================
   COMPONENT
   ========================================================= */

const HarvestHorizonHero = ({

  timeLeft = {
    days: '--',
    hours: '--',
    minutes: '--',
  },

}) => {


  const [activeTab, setActiveTab] =
    useState('day1');


  const [
    heroSlideIndex,
    setHeroSlideIndex,
  ] = useState(0);


  const [
    travelMapQuery,
    setTravelMapQuery,
  ] = useState(
    'Hotels near Raising Nebraska, Grand Island, Nebraska'
  );


  const [
    selectedHotelName,
    setSelectedHotelName,
  ] = useState(null);


  const [
    posterImageOpen,
    setPosterImageOpen,
  ] = useState(false);


  const [
    ftacPosterOpen,
    setFtacPosterOpen,
  ] = useState(false);


  const selectedHotel =
    hotelOptions.find(
      (hotel) =>
        hotel.name === selectedHotelName
    ) || null;


  const travelMapEmbedUrl =
    `https://www.google.com/maps?q=${encodeURIComponent(
      travelMapQuery
    )}&output=embed`;


  const focusTravelLocation = (
    query,
    hotelName = null
  ) => {

    setTravelMapQuery(query);
    setSelectedHotelName(hotelName);

  };


  /* =========================================================
     HERO CAROUSEL AUTO ROTATION
     ========================================================= */

  useEffect(() => {

    const heroInterval =
      window.setInterval(() => {

        setHeroSlideIndex(
          (current) =>
            current ===
              heroSlides.length - 1

              ? 0

              : current + 1
        );

      }, 5000);


    return () => {

      window.clearInterval(
        heroInterval
      );

    };

  }, []);


  const previousHeroSlide = () => {

    setHeroSlideIndex(
      (current) =>
        current === 0

          ? heroSlides.length - 1

          : current - 1
    );

  };


  const nextHeroSlide = () => {

    setHeroSlideIndex(
      (current) =>
        current ===
          heroSlides.length - 1

          ? 0

          : current + 1
    );

  };


  const openRegistration = () => {

    window.open(
      REGISTRATION_URL,
      '_blank',
      'noopener,noreferrer'
    );

  };


  return (

    <>

      {/* =====================================================
          SPUR 2025 HIGHLIGHTS CAROUSEL
          ===================================================== */}

      <section
        className="
          hh-hero
          hh-image-hero
          hh-carousel-hero
        "
        aria-label="Spur 2025 Highlights"
      >


        <div className="hh-carousel-slides">

          {heroSlides.map(
            (slide, index) => (

              <div
                key={slide.label}

                className={`hh-carousel-slide ${index ===
                  heroSlideIndex

                  ? 'active'

                  : ''
                  }`}

                aria-hidden={
                  index !==
                  heroSlideIndex
                }
              >

                <img
                  src={slide.image}

                  alt={slide.alt}

                  className="
                    hh-image-hero-img
                  "

                  style={{
                    objectPosition:
                      slide.position,
                  }}
                />

              </div>

            )
          )}

        </div>


        {/* PHOTO OVERLAY */}

        <div
          className="
            hh-carousel-photo-overlay
          "
        />


        {/* HEADING */}

        <div
          className="
            hh-carousel-highlight-label
          "
        >

          <span>
            Spur AgConverge
          </span>

          <strong>
            2025 Highlights
          </strong>

        </div>


        {/* REGISTER + PROGRAMME */}

        <div
          className="
            hh-image-hero-actions
          "
        >

          <a
            href={REGISTRATION_URL}

            target="_blank"

            rel="noopener noreferrer"

            className="
              hh-image-hero-btn
              hh-image-hero-btn-primary
            "
          >
            Register Now

            <i
              className="
                fas
                fa-arrow-right
              "
            />
          </a>


          <a
            href="#agenda"

            className="
              hh-image-hero-btn
              hh-image-hero-btn-secondary
            "
          >
            View Programme

            <i
              className="
                far
                fa-calendar-alt
              "
            />
          </a>

        </div>


        {/* PREVIOUS */}

        <button
          type="button"

          className="
            hh-carousel-arrow
            hh-carousel-arrow-left
          "

          onClick={
            previousHeroSlide
          }

          aria-label="
            Previous AgConverge highlight
          "
        >
          <i
            className="
              fas
              fa-chevron-left
            "
          />
        </button>


        {/* NEXT */}

        <button
          type="button"

          className="
            hh-carousel-arrow
            hh-carousel-arrow-right
          "

          onClick={
            nextHeroSlide
          }

          aria-label="
            Next AgConverge highlight
          "
        >
          <i
            className="
              fas
              fa-chevron-right
            "
          />
        </button>


        {/* DOTS */}

        <div
          className="
            hh-carousel-dots
          "

          aria-label="
            AgConverge carousel navigation
          "
        >

          {heroSlides.map(
            (slide, index) => (

              <button
                type="button"

                key={slide.label}

                className={`hh-carousel-dot ${index ===
                  heroSlideIndex

                  ? 'active'

                  : ''
                  }`}

                onClick={() =>
                  setHeroSlideIndex(
                    index
                  )
                }

                aria-label={`Show ${slide.label}`}

                aria-current={
                  index ===
                    heroSlideIndex

                    ? 'true'

                    : undefined
                }
              />

            )
          )}

        </div>

      </section>


      {/* =====================================================
          STATS
          ===================================================== */}

      <div className="s-stats">

        <div className="s-stats-inner">


          <div className="s-stat">

            <span className="n">
              8
            </span>

            <span className="l">
              Global startups
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              $1000
            </span>

            <span className="l">
              In Student poster awards
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              2
            </span>

            <span className="l">
              Conference days
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              $6000
            </span>

            <span className="l">
              In Farm Awards
            </span>

          </div>

        </div>

      </div>


      {/* =====================================================
          COUNTDOWN
          ===================================================== */}

      <div className="s-countdown">

        <div className="s-countdown-inner">

          <span
            className="
              s-countdown-label
            "
          >
            Countdown
          </span>


          <div
            className="
              s-countdown-units
            "
          >


            <div className="s-cu">

              <span className="n">
                {timeLeft.days}
              </span>

              <span className="l">
                Days
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.hours}
              </span>

              <span className="l">
                Hrs
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.minutes}
              </span>

              <span className="l">
                Min
              </span>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          WHY AGCONVERGE EXISTS
          ===================================================== */}

      <div className="s-narrative">


        <div className="s-narrative-left">

          <h2>
            Why AgConverge exists
          </h2>


          <p>
            Agriculture does not lack innovation. Every year,
            entrepreneurs launch new technologies, researchers
            generate breakthrough discoveries, and investors
            deploy capital into promising ventures. Yet many
            innovations never make it onto farms and ranches.
            Some are looking for the right customer. Others
            need additional validation. Some solve problems
            that farmers do not actually have. Many simply
            struggle to move beyond pilot projects and early
            adopters. Spur AgConverge was created to help close
            that gap.
          </p>


          <div className="s-pullquote">

            <p>
              “Adoption happens when farmers help shape
              innovation from the beginning — not after
              the pitch deck is done.”
            </p>

          </div>


          <p>
            AgConverge is focused on strengthening the
            entrepreneurial innovation ecosystem across
            agriculture, animal health, food systems, and
            climate technologies throughout Nebraska and
            the Midwest. The conference serves as a platform
            where ideas are tested, partnerships are formed,
            and technologies move closer to real-world
            adoption and impact.
          </p>

        </div>


        {/* RIGHT SIDE */}

        <div className="s-pillar-columns">


          <div
            className="
              s-pillar-main-column
            "
          >


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-seedling" />
              </div>

              <div>

                <h3>
                  Farmer-led validation
                </h3>

                <p>
                  Producers evaluate technologies
                  against real operational challenges —
                  economics, implementation, and fit.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-flask" />
              </div>

              <div>

                <h3>
                  Real-world environments
                </h3>

                <p>
                  Entrepreneurs gain access to
                  on-farm testing through the Spur
                  Validation Sandbox Program.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-school" />
              </div>

              <div>

                <h3>
                  Research partnerships
                </h3>

                <p>
                  Industry and academia collaborate
                  to reduce technical risk and
                  accelerate commercialization.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-coins" />
              </div>

              <div>

                <h3>
                  Capital pathways
                </h3>

                <p>
                  Investors gain clearer signals of
                  market demand and adoption potential
                  from farmer verdicts.
                </p>

              </div>

            </div>

          </div>


          <div
            className="
              s-pillar-divider
            "
            aria-hidden="true"
          />


          {/* REGISTRATION */}

          <div
            className="
              s-ftac-resource-column
            "
          >

            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-rocket" />
              </div>


              <div
                className="
                  s-ftac-resource-content
                "
              >

                <h3>
                  Registration
                </h3>


                <p>
                  Startup registration, student
                  registration, agenda, and awards
                  information.
                </p>


                {/* STARTUP */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--startup
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-rocket
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Startup Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Register your startup for the
                      Farmer Tech Adoption Challenge
                      at Spur AgConverge 2026.
                    </p>

                    <a
                      href={
                        FTAC_STARTUP_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register Startup

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* STUDENT */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--student
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-user-graduate
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Student Poster Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Students, register to attend
                      and take part in the Student
                      Poster Session at Spur
                      AgConverge 2026.
                    </p>

                    <a
                      href={
                        STUDENT_REGISTRATION_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register as a Student

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* AGENDA */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--agenda
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            far
                            fa-calendar-alt
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          AgConverge 2026 Agenda
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Download the full
                      November 17–18, 2026
                      conference agenda.
                    </p>

                    <a
                      href={
                        AgConvergeAgendaPDF
                      }
                      download="
                        Spur_AgConverge_2026_Agenda.pdf
                      "
                      className="
                        s-resource-link
                      "
                    >
                      Download Agenda

                      <i
                        className="
                          fas
                          fa-download
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* AWARDS */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--awards
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-trophy
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Agconverge Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      $6,000 in Farm Awards
                      presented to the top farmer
                      roundtables during FTAC
                      Phase 3: Producer Verdict
                      &amp; Farm Awards.
                    </p>

                    <a
                      href={
                        REGISTRATION_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register Now

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          SESSIONS EXPLORER
          ===================================================== */}

      <section
        className="s-sessions"
        id="agenda"
      >

        <div
          className="
            s-agenda-hero
          "
        >

          <div
            className="
              s-agenda-heading
            "
          >

            <span
              className="
                s-agenda-kicker
              "
            >
              Spur AgConverge 2026
            </span>


            <h2>
              Sessions Explorer
            </h2>


            <p>
              Explore two days of keynotes,
              farmer-led technology evaluation,
              panels, demonstrations, networking,
              and conversations designed to move
              AgTech toward real-world adoption.
            </p>

          </div>


          <div
            className="
              s-agenda-meta
            "
          >

            <div
              className="
                s-agenda-meta-item
              "
            >

              <div
                className="
                  s-agenda-meta-icon
                "
              >
                <i
                  className="
                    far
                    fa-calendar
                  "
                />
              </div>

              <div>

                <span>
                  Date
                </span>

                <strong>
                  November 17–18, 2026
                </strong>

              </div>

            </div>


            <div
              className="
                s-agenda-meta-item
              "
            >

              <div
                className="
                  s-agenda-meta-icon
                "
              >
                <i
                  className="
                    fas
                    fa-map-marker-alt
                  "
                />
              </div>

              <div>

                <span>
                  Location
                </span>

                <strong>
                  Raising Nebraska
                </strong>

                <small>
                  Grand Island, Nebraska
                </small>

              </div>

            </div>

          </div>

        </div>


        {/* DAY TABS */}

        <div
          className="
            s-session-tabs
          "
          role="tablist"
          aria-label="
            Conference agenda days
          "
        >

          {tabs.map(
            (tab) => (

              <button
                type="button"

                role="tab"

                id={`${tab.key}-tab`}

                key={tab.key}

                className={`s-stab ${activeTab ===
                  tab.key

                  ? 'act'

                  : ''
                  }`}

                onClick={() =>
                  setActiveTab(
                    tab.key
                  )
                }

                aria-selected={
                  activeTab ===
                  tab.key
                }

                aria-controls={`${tab.key}-panel`}
              >

                <span
                  className="
                    s-stab-day
                  "
                >
                  {tab.day}
                </span>

                <span
                  className="
                    s-stab-date
                  "
                >
                  {tab.date}
                </span>

              </button>

            )
          )}

        </div>


        {/* SESSION CONTENT */}

        <div
          className="
            s-session-content
          "

          id={`${activeTab}-panel`}

          role="tabpanel"

          aria-labelledby={`${activeTab}-tab`}
        >

          <div
            className="
              s-agenda-day-header
            "
          >

            <div>

              <span
                className="
                  s-agenda-day-label
                "
              >
                {
                  activeTab === 'day1'

                    ? 'Tuesday'

                    : 'Wednesday'
                }
              </span>

              <h3>
                {
                  activeTab === 'day1'

                    ? 'November 17, 2026'

                    : 'November 18, 2026'
                }
              </h3>

            </div>

          </div>


          <div
            className="
              s-scontent
              act
            "
          >

            {
              sessionData[
                activeTab
              ].map((session) => {



                return (

                  <article

                    key={
                      `${session.time}-${session.title}`
                    }


                    className={`s-scard ${session.type

                      ? `is-${session.type}`

                      : ''
                      } ${session.isKeynote

                        ? 's-scard-keynote'

                        : ''
                      }`}


                  >


                    {/* TIME */}

                    <div
                      className="
                        s-scard-time-column
                      "
                    >

                      <span
                        className="
                          s-scard-time
                        "
                      >
                        {session.time}
                      </span>


                      {session.isKeynote && (

                        <span
                          className="
                            s-keynote-featured-label
                          "
                        >
                          Featured
                        </span>

                      )}

                    </div>


                    {/* ICON */}

                    <div
                      className={`s-scard-icon ${session.isKeynote

                        ? 's-keynote-session-icon'

                        : ''
                        }`}
                    >

                      <i
                        className={`fas ${session.icon}`}
                      />

                    </div>


                    {/* DETAILS */}

                    <div
                      className="
                        s-scard-details
                      "
                    >

                      <div
                        className="
                          s-scard-heading
                        "
                      >

                        <h3>
                          {session.title}
                        </h3>


                        {session.badge && (

                          <span
                            className={`s-session-badge ${session.isKeynote

                              ? 's-keynote-badge'

                              : ''
                              }`}
                          >
                            {session.badge}
                          </span>

                        )}

                      </div>


                      {session.desc && (

                        <p>
                          {session.desc}
                        </p>

                      )}


                      {/* FOUNDER × FARMER PARTICIPANTS */}

                      {(session.startupName || session.farmerName) && (

                        <div
                          style={{
                            marginTop: '14px',
                            paddingTop: '13px',
                            borderTop: '1px solid rgba(45, 80, 22, 0.10)',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                            gap: '18px',
                          }}
                        >

                          {session.startupName && (

                            <div>

                              <span
                                style={{
                                  display: 'block',
                                  marginBottom: '3px',
                                  color: '#8a957f',
                                  fontSize: '8px',
                                  fontWeight: 900,
                                  letterSpacing: '0.10em',
                                  textTransform: 'uppercase',
                                }}
                              >
                                Startup
                              </span>

                              <strong
                                style={{
                                  display: 'block',
                                  color: '#34412f',
                                  fontSize: '12px',
                                  fontWeight: 800,
                                }}
                              >
                                {session.startupName}
                              </strong>

                            </div>

                          )}


                          {session.farmerName && (

                            <div>

                              <span
                                style={{
                                  display: 'block',
                                  marginBottom: '3px',
                                  color: '#8a957f',
                                  fontSize: '8px',
                                  fontWeight: 900,
                                  letterSpacing: '0.10em',
                                  textTransform: 'uppercase',
                                }}
                              >
                                Farmer
                              </span>

                              <strong
                                style={{
                                  display: 'block',
                                  color: '#34412f',
                                  fontSize: '12px',
                                  fontWeight: 800,
                                }}
                              >
                                {session.farmerName}
                              </strong>

                            </div>

                          )}

                        </div>

                      )}


                      {/* FTAC SESSION CHAIRS — ONLY SHOWN WHEN PROVIDED */}

                      {session.chairName && (

                        <div
                          style={{
                            marginTop: '14px',
                            paddingTop: '13px',
                            borderTop: '1px solid rgba(45, 80, 22, 0.10)',
                            display: 'grid',
                            gridTemplateColumns: session.coChairName
                              ? 'repeat(2, minmax(0, 1fr))'
                              : 'minmax(0, 1fr)',
                            gap: '18px',
                          }}
                        >

                          <div>

                            <span
                              style={{
                                display: 'block',
                                marginBottom: '3px',
                                color: '#8a957f',
                                fontSize: '8px',
                                fontWeight: 900,
                                letterSpacing: '0.10em',
                                textTransform: 'uppercase',
                              }}
                            >
                              Chair
                            </span>

                            <strong
                              style={{
                                display: 'block',
                                color: '#34412f',
                                fontSize: '12px',
                                fontWeight: 800,
                              }}
                            >
                              {session.chairName}
                            </strong>

                            <a
                              href={`mailto:${session.chairEmail}`}
                              onClick={(event) => event.stopPropagation()}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                marginTop: '5px',
                                color: '#5e7652',
                                fontSize: '10px',
                                fontWeight: 700,
                                textDecoration: 'none',
                              }}
                            >
                              <i
                                className="fas fa-envelope"
                                style={{ color: '#e87722', fontSize: '9px' }}
                              />

                              {session.chairEmail}
                            </a>

                          </div>


                          {session.coChairName && (

                            <div>

                              <span
                                style={{
                                  display: 'block',
                                  marginBottom: '3px',
                                  color: '#8a957f',
                                  fontSize: '8px',
                                  fontWeight: 900,
                                  letterSpacing: '0.10em',
                                  textTransform: 'uppercase',
                                }}
                              >
                                Co-Chair
                              </span>

                              <strong
                                style={{
                                  display: 'block',
                                  color: '#34412f',
                                  fontSize: '12px',
                                  fontWeight: 800,
                                }}
                              >
                                {session.coChairName}
                              </strong>

                              {session.coChairEmail && (

                                <a
                                  href={`mailto:${session.coChairEmail}`}
                                  onClick={(event) => event.stopPropagation()}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    marginTop: '5px',
                                    color: '#5e7652',
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    textDecoration: 'none',
                                  }}
                                >
                                  <i
                                    className="fas fa-envelope"
                                    style={{ color: '#e87722', fontSize: '9px' }}
                                  />

                                  {session.coChairEmail}
                                </a>

                              )}

                            </div>

                          )}

                        </div>

                      )}


                      {/* KEYNOTE SPEAKER — NAME + BIO */}

                      {session.isKeynote && (

                        <div
                          className="
                            s-keynote-speaker-meta
                          "
                        >

                          <span>
                            Keynote Speaker
                          </span>

                          <strong>
                            {session.speakerName}
                          </strong>

                          <small
                            style={{
                              display: 'block',
                              marginTop: '2px',
                              color: '#8a927f',
                              fontSize: '9px',
                              fontWeight: 800,
                              letterSpacing: '0.06em',
                              textTransform: 'uppercase',
                            }}
                          >
                            {session.speakerRole}
                          </small>

                          <p
                            style={{
                              maxWidth: '760px',
                              margin: '9px 0 0',
                              color: '#5f6b58',
                              fontSize: '12px',
                              lineHeight: 1.65,
                            }}
                          >
                            {session.speakerBio}
                          </p>

                        </div>

                      )}



                    </div>


                    {/* KEYNOTE PHOTO */}

                    {session.isKeynote && (

                      <div
                        className="
                          s-keynote-portrait-area
                        "
                      >

                        <div
                          className="
                            s-keynote-portrait-glow
                          "
                        />


                        <div
                          className="
                            s-keynote-portrait-frame
                          "
                        >

                          <img
                            src={
                              session.speakerImage
                            }

                            alt={
                              session.speakerName
                            }

                            className="
                              s-keynote-portrait
                            "
                          />

                        </div>


                      </div>

                    )}

                  </article>

                );

              })
            }

          </div>

        </div>

      </section>


      {/* =====================================================
          STUDENT RESEARCH & INNOVATION POSTER SESSION
          ===================================================== */}

      <section
        id="poster-session"
        style={{
          position: 'relative',
          overflow: 'hidden',
          margin: 0,
          padding: '78px 20px 72px',
          background:
            'linear-gradient(180deg, #edf3f7 0%, #a9c8dd 13%, #8fb6d0 50%, #a7c6d9 84%, #eef3f5 100%)',
          color: '#17324d',
          borderTop:
            '1px solid rgba(8, 43, 79, 0.06)',
          borderBottom:
            '1px solid rgba(8, 43, 79, 0.07)',
        }}
      >

        {/* SUBTLE BACKGROUND TYPOGRAPHY */}

        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: '-24px',
            right: '-18px',
            color: 'rgba(8,43,79,0.055)',
            fontSize: 'clamp(120px, 18vw, 280px)',
            lineHeight: 0.8,
            fontWeight: 900,
            letterSpacing: '-0.07em',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
          }}
        >
          POSTER
        </div>


        <div
          style={{
            position: 'relative',
            zIndex: 1,
            maxWidth: '1180px',
            margin: '0 auto',
          }}
        >

          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                'minmax(0, 1.08fr) minmax(320px, 0.92fr)',
              gap: '56px',
              alignItems: 'center',
            }}
          >

            {/* CONTENT */}

            <div>

              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '9px',
                  marginBottom: '15px',
                  color: '#245b38',
                  fontSize: '14px',
                  fontWeight: 900,
                  letterSpacing: '0.16em',
                  textTransform: 'uppercase',
                }}
              >
                <i className="fas fa-flask" />
                Student Research &amp; Innovation
              </span>


              <h2
                style={{
                  maxWidth: '760px',
                  margin: 0,
                  color: '#082b4f',
                  fontSize: 'clamp(52px, 7vw, 90px)',
                  lineHeight: 0.92,
                  fontWeight: 900,
                  letterSpacing: '-0.055em',
                }}
              >
                Poster
                <br />
                Session
              </h2>


              <p
                style={{
                  maxWidth: '700px',
                  margin: '26px 0 0',
                  color: '#29475d',
                  fontSize: '21px',
                  lineHeight: 1.62,
                }}
              >
                Put your research in front of the people
                who can use it, fund it, build on it, and
                help move it toward real-world impact.
                Undergraduate and graduate researchers
                will present to producers, startups,
                industry partners, and investors throughout
                Spur AgConverge 2026.
              </p>


              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '14px 32px',
                  marginTop: '32px',
                  paddingTop: '25px',
                  borderTop:
                    '1px solid rgba(8,43,79,0.17)',
                }}
              >

                {[
                  ['Dates', 'Nov. 17–18, 2026'],
                  ['Venue', 'Raising Nebraska'],
                  ['Registration closes', 'Oct. 31, 2026'],
                ].map(([label, value]) => (

                  <div key={label}>
                    <span
                      style={{
                        display: 'block',
                        marginBottom: '5px',
                        color: '#496b80',
                        fontSize: '11px',
                        fontWeight: 900,
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                      }}
                    >
                      {label}
                    </span>

                    <strong
                      style={{
                        color: '#082b4f',
                        fontSize: '20px',
                      }}
                    >
                      {value}
                    </strong>
                  </div>

                ))}

              </div>


              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '12px',
                  marginTop: '32px',
                }}
              >

                <a
                  href={STUDENT_REGISTRATION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    minHeight: '54px',
                    padding: '0 24px',
                    borderRadius: '999px',
                    background: '#e87722',
                    color: '#ffffff',
                    fontSize: '15px',
                    fontWeight: 900,
                    textDecoration: 'none',
                    boxShadow:
                      '0 14px 34px rgba(232, 119, 34, 0.20)',
                  }}
                >
                  Register for Poster Session
                  <i className="fas fa-arrow-right" />
                </a>


                <a
                  href="mailto:ilal2@unl.edu"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    minHeight: '54px',
                    padding: '0 16px',
                    color: '#183f5a',
                    fontSize: '14px',
                    fontWeight: 900,
                    textDecoration: 'none',
                  }}
                >
                  Questions? Contact Ishani Lal
                </a>

              </div>

            </div>


            {/* CLICKABLE POSTER ARTWORK */}

            <div
              style={{
                position: 'relative',
                padding: '18px 0 18px 30px',
              }}
            >

              <div
                aria-hidden="true"
                style={{
                  position: 'absolute',
                  inset: '7% -7% -5% 8%',
                  background:
                    'linear-gradient(145deg, rgba(233,244,250,0.90) 0%, rgba(198,220,233,0.90) 100%)',
                  borderRadius: '30px 0 0 30px',
                  transform: 'rotate(2deg)',
                }}
              />


              <button
                type="button"
                onClick={() =>
                  setPosterImageOpen(true)
                }
                aria-label="Enlarge Student Research and Innovation Poster Session flyer"
                style={{
                  position: 'relative',
                  display: 'block',
                  width: '100%',
                  margin: 0,
                  padding: 0,
                  border: 0,
                  background: 'transparent',
                  cursor: 'zoom-in',
                }}
              >

                <img
                  src={PosterSessionFlyer}
                  alt="Spur AgConverge 2026 Student Research and Innovation Poster Session"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: 'auto',
                    borderRadius: '4px',
                    boxShadow:
                      '0 30px 70px rgba(8,43,79,0.22)',
                    transform: 'rotate(-1.2deg)',
                  }}
                />


                <span
                  style={{
                    position: 'absolute',
                    right: '14px',
                    bottom: '14px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '7px',
                    padding: '9px 12px',
                    borderRadius: '999px',
                    background:
                      'rgba(8,43,79,0.90)',
                    color: '#ffffff',
                    fontSize: '11px',
                    fontWeight: 900,
                    boxShadow:
                      '0 8px 20px rgba(0,0,0,0.16)',
                  }}
                >
                  <i className="fas fa-search-plus" />
                  Click to enlarge
                </span>

              </button>

            </div>

          </div>


          {/* AWARDS STRIP */}

          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                '1.35fr repeat(3, minmax(120px, 0.55fr))',
              gap: 0,
              marginTop: '62px',
              borderTop:
                '1px solid rgba(8,43,79,0.16)',
              borderBottom:
                '1px solid rgba(8,43,79,0.16)',
              background:
                'rgba(255,255,255,0.34)',
              backdropFilter: 'blur(4px)',
            }}
          >

            <div
              style={{
                padding: '24px 22px',
              }}
            >
              <span
                style={{
                  display: 'block',
                  marginBottom: '6px',
                  color: '#245b38',
                  fontSize: '11px',
                  fontWeight: 900,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                }}
              >
                External Panel Judging
              </span>

              <strong
                style={{
                  display: 'block',
                  color: '#082b4f',
                  fontSize: '24px',
                }}
              >
                $1,000 in student poster awards
              </strong>

              <span
                style={{
                  display: 'block',
                  marginTop: '6px',
                  color: '#345469',
                  fontSize: '14px',
                  lineHeight: 1.6,
                }}
              >
                Be ready to give a 2–3 minute overview
                during the Day 1 networking reception.
              </span>
            </div>


            {[
              ['1st', '$500'],
              ['2nd', '$300'],
              ['3rd', '$200'],
            ].map(([place, amount]) => (

              <div
                key={place}
                style={{
                  padding: '24px',
                  borderLeft:
                    '1px solid rgba(8,43,79,0.14)',
                }}
              >
                <span
                  style={{
                    display: 'block',
                    color: '#496b80',
                    fontSize: '12px',
                    fontWeight: 900,
                    textTransform: 'uppercase',
                  }}
                >
                  {place} Place
                </span>

                <strong
                  style={{
                    display: 'block',
                    marginTop: '5px',
                    color: '#d96516',
                    fontSize: '34px',
                  }}
                >
                  {amount}
                </strong>
              </div>

            ))}

          </div>


          {/* RESEARCH AREAS */}

          <div
            style={{
              marginTop: '44px',
              maxWidth: '100%',
            }}
          >


            <span
              style={{
                display: 'block',
                marginBottom: '13px',
                color: '#496b80',
                fontSize: '11px',
                fontWeight: 900,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
              }}
            >
              Research Areas
            </span>


            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >

              {[
                'Agricultural Technology',
                'Precision Agriculture',
                'Robotics & Automation',
                'Biosystems Engineering',
                'Artificial Intelligence & Data Science',
                'Water & Nutrient Management',
                'Bio-economy',
                'Crop Production',
                'Sustainability',
              ].map((area) => (

                <span
                  key={area}
                  style={{
                    padding: '9px 12px',
                    borderRadius: '999px',
                    border:
                      '1px solid rgba(8,43,79,0.18)',
                    background:
                      'rgba(255,255,255,0.30)',
                    color: '#183f5a',
                    fontSize: '13px',
                    fontWeight: 800,
                  }}
                >
                  {area}
                </span>

              ))}

            </div>


          </div>


          {/* PRESENTER INSTRUCTIONS */}

          <details
            className="poster-presenter-instructions"
            style={{
              marginTop: '44px',
              borderTop:
                '1px solid rgba(8,43,79,0.18)',
              borderBottom:
                '1px solid rgba(8,43,79,0.18)',
              background:
                'rgba(255,255,255,0.26)',
              backdropFilter: 'blur(4px)',
            }}
          >

            <summary
              style={{
                listStyle: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '18px',
                padding: '22px 4px',
              }}
            >

              <span>

                <span
                  style={{
                    display: 'block',
                    marginBottom: '5px',
                    color: '#245b38',
                    fontSize: '11px',
                    fontWeight: 900,
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                  }}
                >
                  For Student Presenters
                </span>

                <strong
                  style={{
                    display: 'block',
                    color: '#082b4f',
                    fontSize: '24px',
                    lineHeight: 1.25,
                  }}
                >
                  Presenter Instructions
                </strong>

                <span
                  style={{
                    display: 'block',
                    marginTop: '5px',
                    color: '#345469',
                    fontSize: '14px',
                    lineHeight: 1.55,
                  }}
                >
                  Review poster format, setup, judging,
                  presentation, and networking expectations.
                </span>

              </span>


              <span
                className="poster-instructions-toggle"
                aria-hidden="true"
                style={{
                  flexShrink: 0,
                  width: '42px',
                  height: '42px',
                  display: 'grid',
                  placeItems: 'center',
                  borderRadius: '50%',
                  background:
                    'rgba(8,43,79,0.10)',
                  color: '#082b4f',
                  fontSize: '14px',
                }}
              >
                <i className="fas fa-chevron-down" />
              </span>

            </summary>


            <div
              className="poster-instructions-body"
              style={{
                padding: '6px 4px 28px',
              }}
            >

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns:
                    'repeat(2, minmax(0, 1fr))',
                  gap: '28px 44px',
                }}
              >

                {/* BEFORE THE EVENT */}

                <div>

                  <span
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      color: '#245b38',
                      fontSize: '10px',
                      fontWeight: 900,
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                    }}
                  >
                    Before the Event
                  </span>

                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: '20px',
                      color: '#29475d',
                      fontSize: '14px',
                      lineHeight: 1.75,
                    }}
                  >
                    <li>
                      Review your poster with your faculty
                      mentor before the event.
                    </li>
                    <li>
                      One poster is allowed per student.
                    </li>
                    <li>
                      Your work should reflect research or
                      innovation you were substantially
                      involved in during the past year.
                    </li>
                    <li>
                      Watch your email for your poster number
                      and board assignment.
                    </li>
                  </ul>

                </div>


                {/* POSTER FORMAT */}

                <div>

                  <span
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      color: '#245b38',
                      fontSize: '10px',
                      fontWeight: 900,
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                    }}
                  >
                    Poster Format
                  </span>

                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: '20px',
                      color: '#29475d',
                      fontSize: '14px',
                      lineHeight: 1.75,
                    }}
                  >
                    <li>
                      Maximum size: 29 × 40 inches or
                      39 × 48 inches, in either orientation.
                    </li>
                    <li>
                      Do not mount the poster on poster board
                      or foam core.
                    </li>
                    <li>
                      Display board, easel, pushpins, or clips
                      will be provided on site.
                    </li>
                  </ul>

                </div>


                {/* CONTENT + DESIGN */}

                <div>

                  <span
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      color: '#245b38',
                      fontSize: '10px',
                      fontWeight: 900,
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                    }}
                  >
                    Content &amp; Design
                  </span>

                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: '20px',
                      color: '#29475d',
                      fontSize: '14px',
                      lineHeight: 1.75,
                    }}
                  >
                    <li>
                      Explain the problem, your approach,
                      results, and real-world application or
                      impact.
                    </li>
                    <li>
                      Design for producers, startups,
                      industry partners, and investors—not
                      only researchers.
                    </li>
                    <li>
                      Keep jargon limited and spell out
                      acronyms.
                    </li>
                    <li>
                      Aim for roughly 20% text, 40% graphics,
                      and 40% open space.
                    </li>
                    <li>
                      Use a clear sans-serif font with a title
                      at 40 pt or larger, section headings
                      around 36 pt, captions around 24 pt,
                      and narrative text no smaller than
                      18 pt.
                    </li>
                  </ul>

                </div>


                {/* PRESENTING */}

                <div>

                  <span
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      color: '#245b38',
                      fontSize: '10px',
                      fontWeight: 900,
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                    }}
                  >
                    At the Reception
                  </span>

                  <ul
                    style={{
                      margin: 0,
                      paddingLeft: '20px',
                      color: '#29475d',
                      fontSize: '14px',
                      lineHeight: 1.75,
                    }}
                  >
                    <li>
                      Be ready to give a 2–3 minute overview
                      of your work and answer questions.
                    </li>
                    <li>
                      Stand beside your poster rather than in
                      front of it.
                    </li>
                    <li>
                      Practice a short explanation that makes
                      sense to a farmer, investor, and
                      scientist.
                    </li>
                    <li>
                      Business cards, a one-page handout, or
                      a QR code linking to your paper, lab
                      page, or contact information are
                      encouraged.
                    </li>
                    <li>
                      Dress business casual and use the
                      reception as a networking opportunity.
                    </li>
                  </ul>

                </div>

              </div>


              {/* JUDGING */}

              <div
                style={{
                  marginTop: '30px',
                  paddingTop: '24px',
                  borderTop:
                    '1px solid rgba(8,43,79,0.14)',
                  display: 'grid',
                  gridTemplateColumns:
                    'minmax(0, 0.75fr) minmax(0, 1.25fr)',
                  gap: '30px',
                }}
              >

                <div>

                  <span
                    style={{
                      display: 'block',
                      marginBottom: '7px',
                      color: '#245b38',
                      fontSize: '10px',
                      fontWeight: 900,
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                    }}
                  >
                    Judging
                  </span>

                  <strong
                    style={{
                      display: 'block',
                      color: '#082b4f',
                      fontSize: '20px',
                      lineHeight: 1.35,
                    }}
                  >
                    External judges will visit each poster
                    during the Day 1 networking reception.
                  </strong>

                </div>


                <div>

                  <span
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      color: '#496b80',
                      fontSize: '10px',
                      fontWeight: 900,
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                    }}
                  >
                    Judges Will Consider
                  </span>

                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '8px',
                    }}
                  >

                    {[
                      'Significance & relevance',
                      'Research & methods',
                      'Innovation & real-world potential',
                      'Poster clarity & design',
                      'Communication with judges',
                    ].map((item) => (

                      <span
                        key={item}
                        style={{
                          padding: '8px 10px',
                          borderRadius: '999px',
                          background:
                            'rgba(255,255,255,0.32)',
                          border:
                            '1px solid rgba(8,43,79,0.16)',
                          color: '#183f5a',
                          fontSize: '12px',
                          fontWeight: 800,
                        }}
                      >
                        {item}
                      </span>

                    ))}

                  </div>

                </div>

              </div>


              {/* KEY TIMING */}

              <div
                style={{
                  marginTop: '28px',
                  padding: '18px 20px',
                  borderRadius: '14px',
                  background:
                    'rgba(8,43,79,0.08)',
                }}
              >

                <span
                  style={{
                    display: 'block',
                    marginBottom: '10px',
                    color: '#245b38',
                    fontSize: '10px',
                    fontWeight: 900,
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                  }}
                >
                  Key Timing
                </span>


                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns:
                      'repeat(3, minmax(0, 1fr))',
                    gap: '14px',
                  }}
                >

                  <div>
                    <strong
                      style={{
                        display: 'block',
                        color: '#082b4f',
                        fontSize: '15px',
                      }}
                    >
                      Nov. 17 · 9:00 AM
                    </strong>

                    <span
                      style={{
                        color: '#36556a',
                        fontSize: '12px',
                      }}
                    >
                      Poster setup
                    </span>
                  </div>


                  <div>
                    <strong
                      style={{
                        display: 'block',
                        color: '#082b4f',
                        fontSize: '15px',
                      }}
                    >
                      Nov. 17 · 5:00 PM
                    </strong>

                    <span
                      style={{
                        color: '#36556a',
                        fontSize: '12px',
                      }}
                    >
                      Presenter staffing &amp; judging
                    </span>
                  </div>


                  <div>
                    <strong
                      style={{
                        display: 'block',
                        color: '#082b4f',
                        fontSize: '15px',
                      }}
                    >
                      Nov. 18 · 1:00 PM
                    </strong>

                    <span
                      style={{
                        color: '#36556a',
                        fontSize: '12px',
                      }}
                    >
                      Poster removal
                    </span>
                  </div>

                </div>

              </div>

            </div>

          </details>

        </div>


        {/* POSTER IMAGE LIGHTBOX */}

        {posterImageOpen && (

          <div
            role="dialog"
            aria-modal="true"
            aria-label="Enlarged Student Poster Session flyer"
            onClick={() =>
              setPosterImageOpen(false)
            }
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '24px',
              background:
                'rgba(5, 24, 41, 0.88)',
              backdropFilter: 'blur(7px)',
              cursor: 'zoom-out',
            }}
          >

            <button
              type="button"
              onClick={() =>
                setPosterImageOpen(false)
              }
              aria-label="Close enlarged poster"
              style={{
                position: 'fixed',
                top: '20px',
                right: '22px',
                zIndex: 10000,
                display: 'grid',
                placeItems: 'center',
                width: '44px',
                height: '44px',
                border: 0,
                borderRadius: '50%',
                background:
                  'rgba(255,255,255,0.94)',
                color: '#082b4f',
                fontSize: '18px',
                cursor: 'pointer',
                boxShadow:
                  '0 10px 28px rgba(0,0,0,0.20)',
              }}
            >
              <i className="fas fa-times" />
            </button>


            <img
              src={PosterSessionFlyer}
              alt="Enlarged Spur AgConverge 2026 Student Research and Innovation Poster Session flyer"
              onClick={(event) =>
                event.stopPropagation()
              }
              style={{
                display: 'block',
                maxWidth: '96vw',
                maxHeight: '92vh',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                borderRadius: '8px',
                boxShadow:
                  '0 28px 80px rgba(0,0,0,0.38)',
                cursor: 'default',
              }}
            />

          </div>

        )}


        <style>{`
          .poster-presenter-instructions summary::-webkit-details-marker {
            display: none;
          }

          .poster-presenter-instructions[open]
          .poster-instructions-toggle {
            transform: rotate(180deg);
          }

          .poster-instructions-toggle {
            transition: transform 180ms ease;
          }

          @media (max-width: 900px) {
            #poster-session > div:nth-of-type(2) > div:first-of-type {
              grid-template-columns: 1fr !important;
            }

            #poster-session > div:nth-of-type(2) > div:nth-of-type(2) {
              grid-template-columns: 1fr 1fr !important;
            }

            .poster-instructions-body > div:first-child,
            .poster-instructions-body > div:nth-child(2) {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 620px) {
            #poster-session > div:nth-of-type(2) > div:nth-of-type(2) {
              grid-template-columns: 1fr !important;
            }

            .poster-presenter-instructions summary {
              align-items: flex-start !important;
              padding: 19px 2px !important;
            }

            .poster-presenter-instructions summary strong {
              font-size: 21px !important;
            }

            .poster-instructions-body {
              padding-bottom: 22px !important;
            }

            .poster-instructions-body ul {
              font-size: 13px !important;
              padding-left: 18px !important;
            }

            .poster-instructions-body > div:last-child {
              padding: 16px !important;
            }

            .poster-instructions-body > div:last-child > div {
              grid-template-columns: 1fr !important;
            }
          }
        `}</style>

      </section>


      {/* =====================================================
          HOTEL & TRAVEL — RESPONSIVE MAP + HOTEL NAVIGATOR
          ===================================================== */}

      <section
        id="travel"
        className="travel-section"
      >

        <div className="travel-wrap">

          {/* HEADER */}

          <div className="travel-heading">

            <div>

              <span className="travel-kicker">
                <i className="fas fa-map-marked-alt" />
                Plan Your Visit
              </span>

              <h2>
                Raising Nebraska
                <br />
                + Nearby Hotels
              </h2>

            </div>


            <p>
              Start with the conference venue and nearby
              lodging. Select a hotel from the navigator to
              focus the map and open its details without
              changing the map layout.
            </p>

          </div>


          {/* MAP + NAVIGATOR */}

          <div className="travel-map-shell">

            {/* MAP SIDE */}

            <div className="travel-map-side">

              {/* CONTROLS LIVE ABOVE THE MAP — NOTHING COVERS GOOGLE */}

              <div className="travel-map-toolbar">

                <div className="travel-venue-summary">

                  <span>
                    Conference Venue
                  </span>

                  <strong>
                    Raising Nebraska
                  </strong>

                  <small>
                    501 E. Fonner Park Road, Suite 100
                    <br className="travel-mobile-break" />
                    <span className="travel-address-dot">
                      {' · '}
                    </span>
                    Grand Island, NE 68801
                  </small>

                </div>


                <div className="travel-map-actions">

                  <button
                    type="button"
                    onClick={() =>
                      focusTravelLocation(
                        'Hotels near Raising Nebraska, Grand Island, Nebraska'
                      )
                    }
                  >
                    <i className="fas fa-hotel" />
                    Nearby hotels
                  </button>


                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Raising+Nebraska+501+E+Fonner+Park+Road+Grand+Island+NE+68801"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-external-link-alt" />
                    Open in Maps
                  </a>

                </div>

              </div>


              {/* CLEAN MAP CANVAS */}

              <div className="travel-map-canvas">

                <iframe
                  title="Raising Nebraska and nearby AgConverge hotels"
                  src={travelMapEmbedUrl}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />

              </div>

            </div>


            {/* HOTEL NAVIGATOR */}

            <aside className="travel-hotel-nav">

              <div className="travel-hotel-nav-head">

                <span>
                  Nearby Lodging
                </span>

                <strong>
                  Hotel Navigator
                </strong>

                <p>
                  Select a hotel to focus the map and
                  open its information.
                </p>

              </div>


              <div className="travel-hotel-list">

                {hotelOptions.map(
                  (hotel, index) => {

                    const isSelected =
                      selectedHotelName ===
                      hotel.name;

                    return (

                      <button
                        key={hotel.name}
                        type="button"
                        className={`travel-hotel-tab ${isSelected
                          ? 'is-selected'
                          : ''
                          }`}
                        onClick={() =>
                          focusTravelLocation(
                            `${hotel.name}, ${hotel.address}`,
                            hotel.name
                          )
                        }
                      >

                        <span className="travel-hotel-number">
                          {String(index + 1).padStart(2, '0')}
                        </span>


                        <span className="travel-hotel-copy">

                          <span className="travel-hotel-name-row">

                            <strong>
                              {hotel.name}
                            </strong>

                            {hotel.isOfficialBlock && (
                              <span className="travel-official-pill">
                                Official
                              </span>
                            )}

                          </span>


                          <span className="travel-hotel-label">
                            {hotel.label}
                          </span>


                          {hotel.isOfficialBlock && (
                            <span className="travel-hotel-rate-preview">
                              {hotel.specialRate}
                              {' · '}
                              Code {hotel.groupCode}
                            </span>
                          )}

                        </span>


                        <span className="travel-hotel-action">
                          {isSelected
                            ? 'Open'
                            : 'View'}
                        </span>

                      </button>

                    );

                  }
                )}

              </div>


              <div className="travel-nav-foot">
                Grand Island Casino Resort is the official
                Spur AgConverge 2026 hotel.
              </div>


              {/* FLOATING DETAILS — DOES NOT CHANGE MAP OR NAV HEIGHT */}

              {selectedHotel && (

                <div className="travel-floating-hotel">

                  <button
                    type="button"
                    className="travel-floating-close"
                    onClick={() =>
                      focusTravelLocation(
                        'Hotels near Raising Nebraska, Grand Island, Nebraska'
                      )
                    }
                    aria-label="Close hotel details"
                  >
                    <i className="fas fa-times" />
                  </button>


                  <span className="travel-floating-eyebrow">
                    {selectedHotel.isOfficialBlock
                      ? 'Official AgConverge Hotel'
                      : 'Selected Hotel'}
                  </span>


                  <h4>
                    {selectedHotel.name}
                  </h4>


                  <p className="travel-floating-description">
                    {selectedHotel.description}
                  </p>


                  <div className="travel-floating-contact">

                    <div>
                      <i className="fas fa-map-marker-alt" />
                      {selectedHotel.address}
                    </div>

                    <div>
                      <i className="fas fa-phone" />
                      {selectedHotel.phone}
                    </div>

                  </div>


                  {selectedHotel.isOfficialBlock && (

                    <div className="travel-rate-box">

                      <div className="travel-rate-grid">

                        <div>
                          <span>Rate</span>
                          <strong>
                            {selectedHotel.specialRate}
                          </strong>
                        </div>

                        <div>
                          <span>
                            Discount / Group Code
                          </span>
                          <strong>
                            {selectedHotel.groupCode}
                          </strong>
                        </div>

                        <div>
                          <span>
                            Book By
                          </span>
                          <strong>
                            {selectedHotel.bookBy}
                          </strong>
                        </div>

                      </div>


                      <p>
                        {selectedHotel.blockMessage}
                      </p>

                    </div>

                  )}


                  <div className="travel-floating-actions">

                    <a
                      href={selectedHotel.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={
                        selectedHotel.isOfficialBlock
                          ? 'is-primary'
                          : ''
                      }
                    >
                      {selectedHotel.isOfficialBlock
                        ? 'Book Hotel'
                        : 'Hotel Website'}

                      <i className="fas fa-arrow-right" />
                    </a>


                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        `${selectedHotel.name} ${selectedHotel.address}`
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Directions
                      <i className="fas fa-location-arrow" />
                    </a>

                  </div>

                </div>

              )}

            </aside>

          </div>


          {/* TRAVEL ESSENTIALS */}

          <div className="travel-essentials">

            {[
              [
                'Parking',
                'Free accessible parking is available on the west side of the Nebraska Building.',
              ],
              [
                'Airport',
                'Central Nebraska Regional Airport serves Grand Island.',
              ],
              [
                'Local transportation',
                'Rental cars, local transit, taxi service, and regional rail connections are available.',
              ],
            ].map(([title, copy]) => (

              <div key={title}>

                <span>
                  {title}
                </span>

                <p>
                  {copy}
                </p>

              </div>

            ))}

          </div>


          {/* =====================================================
              FTAC POSTER — FEATURED UNDER HOTEL & TRAVEL
              ===================================================== */}

          <div className="travel-ftac-poster">

            <div className="travel-ftac-poster-heading">

              <div>

                <span>
                  Featured at Spur AgConverge 2026
                </span>

                <h3>
                  Farm Tech Adoption Challenge™
                </h3>

              </div>


              <p>
                Farmer-led technology evaluation,
                real-world feedback, and $6,000 in
                Farm Table prizes.
              </p>

            </div>


            <button
              type="button"
              className="travel-ftac-poster-button"
              onClick={() =>
                setFtacPosterOpen(true)
              }
              aria-label="Enlarge Farm Tech Adoption Challenge poster"
            >

              <img
                src={FTACPoster}
                alt="Farm Tech Adoption Challenge at Spur AgConverge 2026"
              />


              <span className="travel-ftac-zoom-label">
                <i className="fas fa-search-plus" />
                Click to enlarge
              </span>

            </button>


            <div className="travel-ftac-poster-actions">

              <span>
                Nov. 17–18, 2026 · Raising Nebraska,
                Grand Island, NE
              </span>


              <a
                href={FTAC_STARTUP_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Register for FTAC
                <i className="fas fa-arrow-right" />
              </a>

            </div>

          </div>


          {/* FTAC POSTER LIGHTBOX */}

          {ftacPosterOpen && (

            <div
              className="travel-ftac-lightbox"
              role="dialog"
              aria-modal="true"
              aria-label="Enlarged Farm Tech Adoption Challenge poster"
              onClick={() =>
                setFtacPosterOpen(false)
              }
            >

              <button
                type="button"
                className="travel-ftac-lightbox-close"
                onClick={() =>
                  setFtacPosterOpen(false)
                }
                aria-label="Close enlarged FTAC poster"
              >
                <i className="fas fa-times" />
              </button>


              <img
                src={FTACPoster}
                alt="Enlarged Farm Tech Adoption Challenge at Spur AgConverge 2026"
                onClick={(event) =>
                  event.stopPropagation()
                }
              />

            </div>

          )}

        </div>


        <style>{`
          .travel-section {
            margin: 0;
            padding: 70px 20px 64px;
            background:
              linear-gradient(180deg, #f5f7f3 0%, #ffffff 100%);
            border-top:
              1px solid rgba(45, 80, 22, 0.07);
          }

          .travel-wrap {
            max-width: 1220px;
            margin: 0 auto;
          }

          .travel-heading {
            display: grid;
            grid-template-columns:
              minmax(0, 1fr) minmax(300px, 0.46fr);
            gap: 46px;
            align-items: end;
            margin-bottom: 30px;
          }

          .travel-kicker {
            display: inline-flex;
            align-items: center;
            gap: 9px;
            margin-bottom: 10px;
            color: #2f6b3a;
            font-size: 13px;
            font-weight: 900;
            letter-spacing: 0.15em;
            text-transform: uppercase;
          }

          .travel-heading h2 {
            margin: 0;
            color: #082b4f;
            font-size: clamp(46px, 6vw, 74px);
            line-height: 0.98;
            font-weight: 900;
            letter-spacing: -0.045em;
          }

          .travel-heading > p {
            margin: 0;
            color: #596758;
            font-size: 18px;
            line-height: 1.7;
          }

          .travel-map-shell {
            position: relative;
            display: grid;
            grid-template-columns:
              minmax(0, 1.68fr) minmax(340px, 0.72fr);
            overflow: hidden;
            border:
              1px solid rgba(8, 43, 79, 0.10);
            border-radius: 24px;
            background: #ffffff;
            box-shadow:
              0 24px 60px rgba(8, 43, 79, 0.10);
          }

          .travel-map-side {
            min-width: 0;
            background: #ffffff;
          }

          .travel-map-toolbar {
            min-height: 94px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 18px;
            padding: 16px 20px;
            border-bottom:
              1px solid rgba(8, 43, 79, 0.09);
            background:
              linear-gradient(90deg, #ffffff 0%, #f7faf5 100%);
          }

          .travel-venue-summary {
            min-width: 0;
          }

          .travel-venue-summary > span {
            display: block;
            margin-bottom: 3px;
            color: #2f6b3a;
            font-size: 9px;
            font-weight: 900;
            letter-spacing: 0.11em;
            text-transform: uppercase;
          }

          .travel-venue-summary > strong {
            display: block;
            color: #082b4f;
            font-size: 19px;
            line-height: 1.2;
          }

          .travel-venue-summary > small {
            display: block;
            margin-top: 4px;
            color: #627061;
            font-size: 12px;
            line-height: 1.45;
          }

          .travel-mobile-break {
            display: none;
          }

          .travel-map-actions {
            flex-shrink: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            gap: 8px;
          }

          .travel-map-actions button,
          .travel-map-actions a {
            min-height: 40px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 7px;
            padding: 0 13px;
            border-radius: 999px;
            font-size: 10px;
            font-weight: 900;
            text-decoration: none;
            white-space: nowrap;
          }

          .travel-map-actions button {
            border: 0;
            background: #edf3e9;
            color: #2f6b3a;
            cursor: pointer;
          }

          .travel-map-actions a {
            background: #082b4f;
            color: #ffffff;
          }

          .travel-map-canvas {
            position: relative;
            width: 100%;
            height: 500px;
            overflow: hidden;
            background: #dfe6dc;
          }

          .travel-map-canvas iframe {
            position: absolute;
            inset: 0;
            display: block;
            width: 100%;
            height: 100% !important;
            min-height: 100% !important;
            max-height: none !important;
            border: 0;
          }

          .travel-hotel-nav {
            position: relative;
            min-width: 0;
            height: 594px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            border-left:
              1px solid rgba(8, 43, 79, 0.08);
            background:
              linear-gradient(180deg, #fbfcfa 0%, #f2f6ef 100%);
          }

          .travel-hotel-nav-head {
            padding: 22px 22px 17px;
            border-bottom:
              1px solid rgba(8, 43, 79, 0.09);
          }

          .travel-hotel-nav-head > span {
            display: block;
            margin-bottom: 5px;
            color: #2f6b3a;
            font-size: 9px;
            font-weight: 900;
            letter-spacing: 0.12em;
            text-transform: uppercase;
          }

          .travel-hotel-nav-head > strong {
            display: block;
            color: #082b4f;
            font-size: 25px;
            line-height: 1.1;
          }

          .travel-hotel-nav-head > p {
            margin: 7px 0 0;
            color: #667365;
            font-size: 12px;
            line-height: 1.5;
          }

          .travel-hotel-list {
            flex: 1;
            min-height: 0;
            overflow-y: auto;
            overscroll-behavior: contain;
          }

          .travel-hotel-tab {
            width: 100%;
            display: grid;
            grid-template-columns:
              30px minmax(0, 1fr) auto;
            gap: 11px;
            align-items: start;
            padding: 16px 20px;
            border: 0;
            border-bottom:
              1px solid rgba(8, 43, 79, 0.08);
            background: transparent;
            text-align: left;
            cursor: pointer;
            transition:
              background 160ms ease,
              box-shadow 160ms ease;
          }

          .travel-hotel-tab.is-selected {
            background:
              linear-gradient(
                90deg,
                rgba(232, 119, 34, 0.13),
                rgba(255, 255, 255, 0.82)
              );
            box-shadow:
              inset 4px 0 0 #e87722;
          }

          .travel-hotel-number {
            padding-top: 2px;
            color: #96a094;
            font-size: 11px;
            font-weight: 900;
            letter-spacing: 0.06em;
          }

          .travel-hotel-tab.is-selected
          .travel-hotel-number {
            color: #e87722;
          }

          .travel-hotel-copy {
            min-width: 0;
          }

          .travel-hotel-name-row {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 6px;
            margin-bottom: 4px;
          }

          .travel-hotel-name-row strong {
            color: #082b4f;
            font-size: 15px;
            line-height: 1.28;
          }

          .travel-official-pill {
            padding: 4px 6px;
            border-radius: 999px;
            background: #fff0df;
            color: #a65316;
            font-size: 7px;
            font-weight: 900;
            letter-spacing: 0.07em;
            text-transform: uppercase;
          }

          .travel-hotel-label {
            display: block;
            color: #71806f;
            font-size: 11px;
            line-height: 1.45;
          }

          .travel-hotel-rate-preview {
            display: block;
            margin-top: 5px;
            color: #9b4d13;
            font-size: 11px;
            font-weight: 900;
          }

          .travel-hotel-action {
            padding-top: 3px;
            color: #71806f;
            font-size: 10px;
            font-weight: 900;
            white-space: nowrap;
          }

          .travel-hotel-tab.is-selected
          .travel-hotel-action {
            color: #e87722;
          }

          .travel-nav-foot {
            padding: 14px 20px;
            border-top:
              1px solid rgba(8, 43, 79, 0.09);
            background:
              rgba(255, 255, 255, 0.78);
            color: #6b7869;
            font-size: 10px;
            line-height: 1.5;
          }

          .travel-floating-hotel {
            position: absolute;
            z-index: 20;
            top: 94px;
            left: 14px;
            right: 14px;
            max-height: calc(100% - 108px);
            overflow-y: auto;
            padding: 21px;
            border-radius: 18px;
            background:
              rgba(255, 255, 255, 0.985);
            border:
              1px solid rgba(8, 43, 79, 0.12);
            box-shadow:
              0 24px 60px rgba(8, 43, 79, 0.22);
            animation:
              hotelFloatOpen 180ms ease-out;
          }

          .travel-floating-close {
            position: absolute;
            top: 11px;
            right: 11px;
            width: 34px;
            height: 34px;
            display: grid;
            place-items: center;
            border: 0;
            border-radius: 50%;
            background: #eef2eb;
            color: #526052;
            cursor: pointer;
          }

          .travel-floating-eyebrow {
            display: block;
            margin-bottom: 6px;
            color: #2f6b3a;
            font-size: 9px;
            font-weight: 900;
            letter-spacing: 0.11em;
            text-transform: uppercase;
          }

          .travel-floating-hotel h4 {
            margin: 0 42px 9px 0;
            color: #082b4f;
            font-size: 21px;
            line-height: 1.2;
          }

          .travel-floating-description {
            margin: 0 0 11px;
            color: #536252;
            font-size: 12px;
            line-height: 1.6;
          }

          .travel-floating-contact {
            margin-bottom: 13px;
            color: #60705e;
            font-size: 11px;
            line-height: 1.7;
          }

          .travel-floating-contact i {
            width: 17px;
          }

          .travel-floating-contact
          .fa-map-marker-alt {
            color: #e87722;
          }

          .travel-floating-contact
          .fa-phone {
            color: #2f6b3a;
          }

          .travel-rate-box {
            margin: 14px 0;
            padding: 14px;
            border:
              1px solid rgba(232, 119, 34, 0.20);
            border-radius: 13px;
            background: #fff3e7;
          }

          .travel-rate-grid {
            display: grid;
            grid-template-columns:
              repeat(3, minmax(0, 1fr));
            gap: 11px;
            margin-bottom: 10px;
          }

          .travel-rate-grid span {
            display: block;
            margin-bottom: 3px;
            color: #956a49;
            font-size: 8px;
            font-weight: 900;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }

          .travel-rate-grid strong {
            color: #7d461d;
            font-size: 13px;
            line-height: 1.4;
            overflow-wrap: anywhere;
          }

          .travel-rate-grid > div:first-child strong {
            color: #a65316;
            font-size: 16px;
          }

          .travel-rate-box p {
            margin: 0;
            color: #765b46;
            font-size: 10px;
            line-height: 1.55;
          }

          .travel-floating-actions {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-top: 13px;
          }

          .travel-floating-actions a {
            min-height: 39px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 0 12px;
            border-radius: 999px;
            background: #edf2e9;
            color: #365737;
            font-size: 10px;
            font-weight: 900;
            text-decoration: none;
          }

          .travel-floating-actions
          a.is-primary {
            background: #e87722;
            color: #ffffff;
          }

          .travel-essentials {
            display: grid;
            grid-template-columns:
              repeat(3, minmax(0, 1fr));
            margin-top: 34px;
            border-top:
              1px solid rgba(8, 43, 79, 0.12);
            border-bottom:
              1px solid rgba(8, 43, 79, 0.12);
          }

          .travel-essentials > div {
            padding: 22px 24px;
          }

          .travel-essentials > div + div {
            border-left:
              1px solid rgba(8, 43, 79, 0.12);
          }

          .travel-essentials span {
            display: block;
            margin-bottom: 7px;
            color: #2f6b3a;
            font-size: 10px;
            font-weight: 900;
            letter-spacing: 0.10em;
            text-transform: uppercase;
          }

          .travel-essentials p {
            margin: 0;
            color: #596758;
            font-size: 14px;
            line-height: 1.65;
          }

          @keyframes hotelFloatOpen {
            from {
              opacity: 0;
              transform:
                translateY(8px) scale(0.98);
            }

            to {
              opacity: 1;
              transform:
                translateY(0) scale(1);
            }
          }


          /* FTAC POSTER UNDER HOTELS */

          .travel-ftac-poster {
            margin-top: 64px;
            padding-top: 34px;
            border-top:
              1px solid rgba(8, 43, 79, 0.12);
          }

          .travel-ftac-poster-heading {
            display: grid;
            grid-template-columns:
              minmax(0, 1fr) minmax(280px, 0.48fr);
            gap: 36px;
            align-items: end;
            margin-bottom: 22px;
          }

          .travel-ftac-poster-heading
          > div > span {
            display: block;
            margin-bottom: 7px;
            color: #2f6b3a;
            font-size: 11px;
            font-weight: 900;
            letter-spacing: 0.13em;
            text-transform: uppercase;
          }

          .travel-ftac-poster-heading h3 {
            margin: 0;
            color: #082b4f;
            font-size:
              clamp(32px, 4.4vw, 52px);
            line-height: 1;
            font-weight: 900;
            letter-spacing: -0.035em;
          }

          .travel-ftac-poster-heading > p {
            margin: 0;
            color: #596758;
            font-size: 16px;
            line-height: 1.65;
          }

          .travel-ftac-poster-button {
            position: relative;
            display: block;
            width: 100%;
            margin: 0;
            padding: 0;
            overflow: hidden;
            border:
              1px solid rgba(8, 43, 79, 0.11);
            border-radius: 22px;
            background: #ffffff;
            cursor: zoom-in;
            box-shadow:
              0 22px 56px rgba(8, 43, 79, 0.12);
          }

          .travel-ftac-poster-button img {
            display: block;
            width: 100%;
            height: auto;
          }

          .travel-ftac-zoom-label {
            position: absolute;
            right: 16px;
            bottom: 16px;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            padding: 10px 13px;
            border-radius: 999px;
            background:
              rgba(8, 43, 79, 0.92);
            color: #ffffff;
            font-size: 10px;
            font-weight: 900;
            box-shadow:
              0 9px 22px rgba(0, 0, 0, 0.18);
          }

          .travel-ftac-poster-actions {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 18px;
            margin-top: 18px;
          }

          .travel-ftac-poster-actions > span {
            color: #61705f;
            font-size: 13px;
            line-height: 1.55;
          }

          .travel-ftac-poster-actions > a {
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            min-height: 44px;
            padding: 0 17px;
            border-radius: 999px;
            background: #2f6b3a;
            color: #ffffff;
            font-size: 11px;
            font-weight: 900;
            text-decoration: none;
          }

          .travel-ftac-lightbox {
            position: fixed;
            inset: 0;
            z-index: 10020;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 24px;
            background:
              rgba(5, 24, 41, 0.90);
            backdrop-filter: blur(8px);
            cursor: zoom-out;
          }

          .travel-ftac-lightbox > img {
            display: block;
            max-width: 96vw;
            max-height: 92vh;
            width: auto;
            height: auto;
            object-fit: contain;
            border-radius: 10px;
            box-shadow:
              0 30px 90px rgba(0, 0, 0, 0.40);
            cursor: default;
          }

          .travel-ftac-lightbox-close {
            position: fixed;
            top: 20px;
            right: 22px;
            z-index: 10021;
            width: 44px;
            height: 44px;
            display: grid;
            place-items: center;
            border: 0;
            border-radius: 50%;
            background:
              rgba(255, 255, 255, 0.95);
            color: #082b4f;
            font-size: 18px;
            cursor: pointer;
            box-shadow:
              0 10px 28px rgba(0, 0, 0, 0.22);
          }

          /* TABLET */

          @media (max-width: 1100px) {
            .travel-section {
              padding:
                58px 18px 56px;
            }

            .travel-heading {
              grid-template-columns: 1fr;
              gap: 18px;
            }

            .travel-heading > p {
              max-width: 720px;
            }

            .travel-map-shell {
              grid-template-columns: 1fr;
            }

            .travel-hotel-nav {
              height: 520px;
              border-left: 0;
              border-top:
                1px solid rgba(8, 43, 79, 0.08);
            }

            .travel-hotel-list {
              display: grid;
              grid-template-columns:
                repeat(2, minmax(0, 1fr));
            }

            .travel-hotel-tab {
              min-height: 102px;
            }

            .travel-hotel-tab:nth-child(odd) {
              border-right:
                1px solid rgba(8, 43, 79, 0.08);
            }

            .travel-ftac-poster-heading {
              grid-template-columns: 1fr;
              gap: 12px;
            }

            .travel-ftac-poster-heading > p {
              max-width: 720px;
            }

            .travel-floating-hotel {
              top: 88px;
              left: 18px;
              right: 18px;
              max-height:
                calc(100% - 108px);
            }
          }

          /* PHONE */

          @media (max-width: 700px) {
            .travel-section {
              padding:
                48px 14px 48px;
            }

            .travel-heading {
              margin-bottom: 22px;
            }

            .travel-heading h2 {
              font-size:
                clamp(38px, 11vw, 52px);
            }

            .travel-heading > p {
              font-size: 16px;
            }

            .travel-map-shell {
              border-radius: 18px;
            }

            .travel-map-toolbar {
              min-height: auto;
              display: block;
              padding: 14px;
            }

            .travel-venue-summary > strong {
              font-size: 17px;
            }

            .travel-mobile-break {
              display: block;
            }

            .travel-address-dot {
              display: none;
            }

            .travel-map-actions {
              display: grid;
              grid-template-columns:
                1fr 1fr;
              gap: 8px;
              margin-top: 13px;
            }

            .travel-map-actions button,
            .travel-map-actions a {
              width: 100%;
              min-height: 43px;
              padding: 0 9px;
              font-size: 9px;
            }

            .travel-map-canvas {
              height: 400px;
            }

            .travel-hotel-nav {
              height: 540px;
            }

            .travel-hotel-nav-head {
              padding: 20px 17px 15px;
            }

            .travel-hotel-nav-head
            > strong {
              font-size: 23px;
            }

            .travel-hotel-list {
              display: block;
            }

            .travel-hotel-tab {
              min-height: auto;
              grid-template-columns:
                26px minmax(0, 1fr) auto;
              padding: 15px 16px;
            }

            .travel-hotel-tab:nth-child(odd) {
              border-right: 0;
            }

            .travel-hotel-name-row strong {
              font-size: 14px;
            }

            .travel-hotel-action {
              font-size: 9px;
            }

            .travel-floating-hotel {
              top: 88px;
              left: 10px;
              right: 10px;
              max-height:
                calc(100% - 100px);
              padding: 18px;
              border-radius: 15px;
            }

            .travel-rate-grid {
              grid-template-columns: 1fr;
              gap: 10px;
            }

            .travel-rate-grid > div {
              padding-bottom: 8px;
              border-bottom:
                1px solid rgba(232, 119, 34, 0.13);
            }

            .travel-rate-grid
            > div:last-child {
              padding-bottom: 0;
              border-bottom: 0;
            }

            .travel-floating-actions {
              display: grid;
              grid-template-columns: 1fr 1fr;
            }

            .travel-floating-actions a {
              width: 100%;
              padding: 0 8px;
            }

            .travel-essentials {
              grid-template-columns: 1fr;
            }

            .travel-essentials > div + div {
              border-left: 0;
              border-top:
                1px solid rgba(8, 43, 79, 0.12);
            }

            .travel-essentials > div {
              padding: 18px 4px;
            }

            .travel-ftac-poster {
              margin-top: 46px;
              padding-top: 26px;
            }

            .travel-ftac-poster-heading {
              margin-bottom: 16px;
            }

            .travel-ftac-poster-heading h3 {
              font-size:
                clamp(30px, 9vw, 42px);
            }

            .travel-ftac-poster-heading > p {
              font-size: 14px;
            }

            .travel-ftac-poster-button {
              border-radius: 16px;
            }

            .travel-ftac-zoom-label {
              right: 10px;
              bottom: 10px;
              padding: 8px 10px;
              font-size: 9px;
            }

            .travel-ftac-poster-actions {
              display: grid;
              grid-template-columns: 1fr;
              gap: 12px;
            }

            .travel-ftac-poster-actions > a {
              width: 100%;
            }

            .travel-ftac-lightbox {
              padding: 12px;
            }

            .travel-ftac-lightbox > img {
              max-width: 98vw;
              max-height: 88vh;
              border-radius: 6px;
            }
          }

          /* SMALL PHONE */

          @media (max-width: 430px) {
            .travel-map-actions {
              grid-template-columns: 1fr;
            }

            .travel-map-canvas {
              height: 350px;
            }

            .travel-hotel-nav {
              height: 520px;
            }

            .travel-floating-actions {
              grid-template-columns: 1fr;
            }
          }
        `}</style>

      </section>


      {/* =====================================================
          FARMERS TECH ADOPTION CHALLENGE
          ===================================================== */}

      <div className="s-ftac">

        <div className="s-ftac-inner">

          <h2>
            The Farmers Tech Adoption
            Challenge™
          </h2>


          <p className="sub">
            A first-of-its-kind farmer-led market
            validation platform — the only event
            in agriculture where producers
            evaluate technologies live, on stage,
            in front of investors and industry.
          </p>


          <div
            className="
              s-ftac-track
            "
          >


            <div className="s-fbox">

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 01
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                01
              </div>

              <h3>
                Startup Showcase
              </h3>

              <p>
                8 selected startups ·
                8 minutes each · live
                Q&amp;A · technologies
                from across the U.S.
                and the world
              </p>

            </div>


            <div className="s-farrow">
              <i
                className="
                  fas
                  fa-arrow-right
                "
              />
            </div>


            <div
              className="
                s-fbox
                center
              "
            >

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 02
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                02
              </div>

              <h3>
                Farmer Roundtables
              </h3>

              <p>
                Producers evaluate each
                technology on economics,
                ease of implementation,
                scalability, and adoption
                likelihood
              </p>

            </div>


            <div className="s-farrow">
              <i
                className="
                  fas
                  fa-arrow-right
                "
              />
            </div>


            <div className="s-fbox">

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 03
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                03
              </div>

              <h3>
                Producer Verdict
              </h3>

              <p>
                Roundtables report findings ·
                independent judges score ·
                Farm Awards presented ·
                commercialization pathways
                identified
              </p>

            </div>

          </div>


          <div
            className="
              s-ftac-cta
            "
          >

            <button
              type="button"

              className="
                btn-og3
              "

              onClick={
                openRegistration
              }
            >
              Register for FTAC™
            </button>

          </div>

        </div>

      </div>


      {/* =====================================================
          VENUE
          ===================================================== */}

      <div className="s-venue">

        <div
          className="
            s-venue-inner
          "
        >


          <div className="s-v">

            <div className="s-v-label">
              Venue
            </div>

            <div className="s-v-val">
              Raising Nebraska
            </div>

            <div className="s-v-sub">
              Grand Island,
              Nebraska 68801
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Date
            </div>

            <div className="s-v-val">
              November 17, 2026
            </div>

            <div className="s-v-sub">
              8:00 AM – 6:30 PM
            </div>

            <div className="s-v-val">
              November 18, 2026
            </div>

            <div className="s-v-sub">
              8:00 AM – 12:00 PM
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Hosted by
            </div>

            <div className="s-v-val">
              Spur Ventures at UNL
            </div>

            <div className="s-v-sub">
              University of
              Nebraska–Lincoln
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Parking
            </div>

            <div className="s-v-val">
              Free on-site
            </div>

            <div className="s-v-sub">
              ADA accessible ·
              WiFi included
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Catering
            </div>

            <div className="s-v-val">
              Breakfast &amp; lunch
            </div>

            <div className="s-v-sub">
              Included with registration
            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          CLOSING CTA
          ===================================================== */}

      <div className="s-cta">

        <h2>
          Join AgConverge '26
        </h2>


        <p>
          The result is more than a conference —
          a platform for validation, adoption,
          ecosystem building, and investment in
          the Midwest&apos;s agricultural future.
        </p>


        <div
          className="
            s-cta-chips
          "
        >

          <span className="s-chip">
            <i className="fas fa-check" />
            Lunch included
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Live FTAC™
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Robotics arena
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Women in Ag Forum
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Farm Awards
          </span>

        </div>


        <button
          type="button"

          className="
            btn-og3
          "

          style={{
            fontSize:
              '15px',

            padding:
              '14px 36px',
          }}

          onClick={
            openRegistration
          }
        >
          Register Now
        </button>

      </div>

    </>

  );

};


export default HarvestHorizonHero;
